/* eslint-disable react-hooks/exhaustive-deps */
import { cloneDeep } from 'lodash';
import React, { useEffect, useState } from 'react'
import { deleteBankTransMappingTags, getBankTransMappingTagsList } from '../../../apis/finances/bank';
import Filters from '../../../components/Filters';
import PageHeader from '../../../components/PageHeader';
import Profile from '../../../components/Profile';
import { ControlTable } from '../../../components/Table';
import { CONDITION_TYPE } from '../../../constants/TAG';
import useForm from '../../../hooks/useForm';
import { viewLoading } from '../../../utils/loading';
import { isEmpty } from '../../../utils/lodashExtend';
import { getParams } from '../../../utils/params';
import systemAlert from '../../../utils/systemAlert';
import { classnames } from '../../../utils/text';
import { translation } from '../../../utils/translator';
import TagClientMapping from './TagClientMapping';

const TagClientMappingList = (props) => {
  const { activeTab, tabList, permission } = props


  const [detailOpen, setDetailOpen] = useState(false)

  const [fields] = useState([
    {
      title: '거래처명',
      key: 'client.name'
    },
    {
      title: '거래자명',
      key: 'traderNameText',
      onValue: (value, field, data) => {
        return (
          !isEmpty(value)
            ? (
              <>
                <span className="font-bold">{value}</span>
                <span className="ml-4">({translation(CONDITION_TYPE, data.traderNameCondition)})</span>
              </>
            )
            : '미지정'
        )
      }
    },
    {
      title: '입금자',
      key: 'sendBankAccountHolderText',
      onValue: (value, field, data) => {
        return (
          !isEmpty(value)
            ? (
              <>
                <span className="font-bold">{value}</span>
                <span className="ml-4">({translation(CONDITION_TYPE, data.sendBankAccountHolderCondition)})</span>
              </>
            )
            : '미지정'
        )
      }

    },
    {
      title: '적요',
      key: 'remarkText',
      onValue: (value, field, data) => {
        return (
          !isEmpty(value)
            ? (
              <>
                <span className="font-bold">{value}</span>
                <span className="ml-4">({translation(CONDITION_TYPE, data.remarkCondition)})</span>
              </>
            )
            : '미지정'
        )
      }
    },
    {
      title: '적요(상세)',
      key: 'detailText',
      onValue: (value, field, data) => {
        return (
          !isEmpty(value)
            ? (
              <>
                <span className="font-bold">{value}</span>
                <span className="ml-4">({translation(CONDITION_TYPE, data.detailCondition)})</span>
              </>
            )
            : '미지정'
        )
      }
    },
    {
      title: '등록일',
      key: 'createdTime',
      type: 'date'
    },
    {
      title: '등록자',
      key: 'writeEmployeeIdx',
      onValue: (value) => {
        return (
          <Profile employeeIdx={value} />
        )
      }
    }
  ]);

  const [filters] = useState([
    {
      title: "거래처 검색",
      type: "input",
      key: "search.clientName",
      placeholder: "검색어 입력",
    },
    {
      title: "거래자명 검색",
      type: "input",
      key: "search.traderNameText",
      placeholder: "거래자명 입력",
    },
  ])
  const [_activeTab, _setActiveTab] = useState(0);

  const _tabList = [
    {
      label: "전체",
      action: _setActiveTab,
    },
    {
      label: "거래처",
      action: _setActiveTab,
    },
    {
      label: "카드사",
      action: _setActiveTab,
    },
    {
      label: "카드사용처",
      action: _setActiveTab,
    },
    {
      label: "직원",
      action: _setActiveTab,
    },
  ];

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      order: [
        {
          createdTime: "desc"
        }
      ],
      search: {
        clientName: ""
      },
      includeDeleted: false,
      clientType: [],
      page: 0,
      limit: 10
    }
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, [_activeTab]);

  const submit = (params) => {
    const _params = cloneDeep(params)

    switch (_activeTab)
    {
      case 0:
        _params.clientType.push('company', 'cardCompany', 'cardUseStore', 'employee')
        break;
      case 1:
        _params.clientType.push('company')
        break;
      case 2:
        _params.clientType.push('cardCompany')
        break;
      case 3:
        _params.clientType.push('cardUseStore')
        break;
      case 4:
        _params.clientType.push('employee')
        break;
      default:
        break;
    }
    getBankTransMappingTagsList(getParams(_params))
      .then((res) => {
        setList(res.data.mappingTagList)
        setTotal(res.data.totalCount)
      })
      .catch(() => { })
      .finally(() => {
        setIsLoading(false)
      })
  };

  const rowBtnConfig = {
    title: '태그 삭제',
    rowButtons: [
      {
        type: "delete",
        action: (data) => {
          systemAlert('해당 태그를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  viewLoading(true)
                  deleteBankTransMappingTags(data.idx)
                    .then(() => {
                      submit(form)
                    })
                    .catch(() => { })
                    .finally(() => viewLoading(false))
                }
              }
            ]
          })
        },
      },
    ],
  };

  const tagHeaderButtons = [
    {
      label: '매핑 항목 추가',
      action: () => {
        setDetailOpen(true)
      },
    },
  ]


  return (
    <div className="tag-client-mapping-list">


      <PageHeader
        title={"은행 입출금 내역"}
        activeTab={activeTab}
        tabList={tabList}
        buttons={tagHeaderButtons}
      />
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ul className="tag-client-tab-list">
        {_tabList.map(({ label, action }, idx) => (
          <li
            key={idx}
            className={classnames({ active: _activeTab === idx })}
            onClick={() => action(idx)}
          >
            {label}
          </li>
        ))}
      </ul>
      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        submit={handleSubmit}
        rowBtn={permission.level > 1 ? rowBtnConfig : {}}
      />
      <TagClientMapping
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={() => submit(form)}
      />
    </div>
  )
}

export default TagClientMappingList;